import './Value.css';
export var valueStyle = '_1euwfb00-3-8-0';